import { apiGet, apiPost, apiPatch, apiDelete } from '@lib/api/client';
import type { QuickAccessScreen, QuickAccessInput, MineScreen } from './types';

export const quickAccessApi = {
  // ── الإدارة ──────────────────────────────────────────────────────────────
  list: () => apiGet<{ data: QuickAccessScreen[] }>('/api/quick-access'),
  get: (id: string) => apiGet<{ data: QuickAccessScreen }>(`/api/quick-access/${id}`),
  create: (body: QuickAccessInput) =>
    apiPost<{ data: QuickAccessScreen }, QuickAccessInput>('/api/quick-access', body),
  update: (id: string, body: QuickAccessInput) =>
    apiPatch<{ data: QuickAccessScreen }, QuickAccessInput>(`/api/quick-access/${id}`, body),
  remove: (id: string) => apiDelete<{ ok: boolean }>(`/api/quick-access/${id}`),

  // ── المستخدم النهائي ──────────────────────────────────────────────────────
  mineList: () => apiGet<{ data: MineScreen[] }>('/api/quick-access/mine/list'),
  mine: (id: string) => apiGet<{ data: QuickAccessScreen }>(`/api/quick-access/mine/${id}`),
  myHome: () =>
    apiGet<{ home: string | null; hide_sidebar: boolean }>('/api/quick-access/mine/home'),
};
